module.exports = "<div class=\"gw-tabbable\">\n    <ul class=\"gw-nav {{type && 'gw-nav-' + type}}\" ng-class=\"{'gw-nav-stacked': vertical}\" ng-transclude>\n    </ul>\n    <div class=\"gw-tab-content\">\n        <div class=\"gw-tab-pane\"\n             ng-repeat=\"tab in tabs\"\n             ng-class=\"{'gw-active': tab.active}\"\n             tab-content-transclude=\"tab\">\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/tabs/templates/tabset-template.html
// module id = 489
// module chunks = 0